import axios from 'axios';
import {useState} from 'react'
import { Link } from 'react-router-dom';



const PasswordReset = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState(false);
    const handleSubmit = async (e) => {
      e.preventDefault();
      setMessage('');
      setError('');
      setIsLoading(true);

      if (!email) {
        setError('Please enter your email address');
        setIsLoading(false);
        return;
      }

      try {
      // const response = await axios.post('https://lightningpresort-3c0bfe3acad3.herokuapp.com/user/forgot-password', { email });
       const response = await axios.post('http://localhost:5009/user/forgot-password', { email });
       if(response.data.status === 200){setStatus(true)}
        setMessage(response.data.message);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to send reset link');
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">Reset Your Password</h2>
          <p className="text-center text-gray-600 mb-6">
            Enter your email address, and we'll send you a link to reset your password.
          </p>
          {message && <div className="mb-4 p-3 bg-green-100 text-green-700 rounded">{message}</div>}
          {error && <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">{error}</div>}
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="you@example.com"
              />
            </div>
            {!status ? <>       <button
              onClick={handleSubmit}
              disabled={isLoading}
              className={`w-full py-2 px-4 bg-blue-600 text-white rounded hover:bg-blue-700 transition duration-200 ${
                isLoading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {isLoading ? 'Sending...' : 'Send Reset Link'}
              
            </button> </> : <> Did not get email? <button
              onClick={handleSubmit}
              disabled={isLoading}
              className={`w-full py-2 px-4 bg-blue-600 text-white rounded hover:bg-blue-700 transition duration-200 ${
                isLoading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {isLoading ? 'Sending...' : 'Resend Reset Link'}
              
            </button></>}


            
     
          </div>
          <p className="mt-4 text-center text-sm text-gray-600">
            Back to <Link to="/" className="text-blue-600 hover:underline" replace>Login</Link>
          </p>
        </div>
      </div>
    )
}
    export default PasswordReset